import { render, staticRenderFns } from "./EventDialogInput.vue?vue&type=template&id=08168cf3&scoped=true&"
import script from "./EventDialogInput.vue?vue&type=script&lang=js&"
export * from "./EventDialogInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08168cf3",
  null
  
)

export default component.exports